// ui/src/ui/pinned-projects.ts
export function addPin(ids: string[], id: string): string[] {
  return ids.includes(id) ? ids : [...ids, id];
}
export function removePin(ids: string[], id: string): string[] {
  return ids.filter((x) => x !== id);
}

export interface SessionLike { id: string; metadata?: { label?: string; sessionKey?: string } | null; }

export function sessionDisplayLabel(s: SessionLike): string {
  const label = s.metadata?.label;
  if (label && label.trim()) return label.trim();
  const key = s.metadata?.sessionKey;
  if (key) {
    const seg = key.split(":").pop(); // last segment is the label part of agent:..:project:..:<label>
    if (seg && seg.trim()) return seg.trim();
  }
  return s.id.slice(0, 8);
}
